import APIService from './class';

class Expenses extends APIService {
  constructor() {
    super( '/expense' );
  }
}

export default new Expenses();